// Shared IANA timezone list — single source of truth for all timezone selectors.
// Values are IANA timezone identifiers (e.g. "America/New_York") which handle
// Daylight Saving Time automatically. Sorted alphabetically.

export const DEFAULT_TIMEZONE = 'America/New_York';

export const TIMEZONES = [
  'Africa/Cairo', 'Africa/Casablanca', 'Africa/Johannesburg', 'Africa/Lagos', 'Africa/Nairobi',
  'America/Anchorage', 'America/Argentina/Buenos_Aires', 'America/Bogota', 'America/Caracas',
  'America/Chicago', 'America/Denver', 'America/Halifax', 'America/Los_Angeles',
  'America/Mexico_City', 'America/New_York', 'America/Phoenix', 'America/Santiago',
  'America/Sao_Paulo', 'America/Toronto',
  'Asia/Almaty', 'Asia/Bangkok', 'Asia/Dhaka', 'Asia/Dubai', 'Asia/Kabul', 'Asia/Karachi',
  'Asia/Kathmandu', 'Asia/Kolkata', 'Asia/Riyadh', 'Asia/Shanghai', 'Asia/Singapore',
  'Asia/Taipei', 'Asia/Tashkent', 'Asia/Tehran', 'Asia/Tokyo', 'Asia/Yangon',
  'Atlantic/Azores', 'Atlantic/South_Georgia',
  'Australia/Adelaide', 'Australia/Brisbane', 'Australia/Darwin', 'Australia/Lord_Howe',
  'Australia/Perth', 'Australia/Sydney',
  'Europe/Athens', 'Europe/Berlin', 'Europe/Helsinki', 'Europe/London', 'Europe/Moscow',
  'Europe/Paris',
  'Pacific/Auckland', 'Pacific/Fiji', 'Pacific/Guam', 'Pacific/Honolulu', 'Pacific/Midway',
  'Pacific/Noumea', 'Pacific/Tongatapu',
];
